(function () {

    'use strict';

    var ngModule = angular.module('breakmarkApp');

	ngModule.directive('storePackagesTable', function ($rootScope, ModalService, $uibModal) {

		return {
			scope: {
				store: '='
			},
			templateUrl: 'directives/storePackagesTable/table.html',
			controller: function($scope) {
				if (!$scope.store.packages) $scope.store.packages = [];

				$scope.delete = function(thisPackage) {

                    let scope = $scope; // need this inside the controller for the modal

                    let modalInstance = $uibModal.open({
                        animation: true,
                        template: `
                            <div class="modal-header">
                                <h3 class="modal-title">Delete "${thisPackage.name}"?</h3>
                            </div>
                            <div class="modal-footer">
                                <button class="btn btn-default" type="button" ng-click="cancel()">Cancel</button>
                                <button class="btn btn-danger" type="button" ng-click="delete()">Delete</button>
                            </div>`,
                        controller: function($scope, $uibModalInstance, thisPackage) {

                            $scope.delete = function () {

                                var index = scope.store.packages.indexOf(thisPackage);

                                if (index > -1) scope.store.packages.splice(index, 1);

                                scope.store.$save();

                                $uibModalInstance.close(thisPackage);
                            };

                            $scope.cancel = function () {
                                $uibModalInstance.dismiss('cancel');
                            };

                        },
                        resolve: {
                            thisPackage: function() {
                                return thisPackage;
                            }
                        },
                        size: 'sm'
                    });

				};

				/* Make a copy of a given package */
				$scope.copy = function(thisPackage) {

                    let scope = $scope; // need this inside the controller for the modal

                    let modalInstance = $uibModal.open({
                        animation: true,
                        template: `
                            <div class="modal-header">
                                <h3 class="modal-title">Copy "${thisPackage.name}"?</h3>
                            </div>
                            <div class="modal-footer">
                                <button class="btn btn-default" type="button" ng-click="cancel()">Cancel</button>
                                <button class="btn btn-success" type="button" ng-click="copy()">Copy</button>
                            </div>`,
                        controller: function($scope, $uibModalInstance, thisPackage) {

                            $scope.copy = function () {

                                let copy = angular.copy(thisPackage);

                                copy.name = 'Copy of ' + copy.name;

                                scope.store.packages.push(copy);

                                scope.store.$save();

                                $uibModalInstance.close(copy);
                            };

                            $scope.cancel = function () {
                                $uibModalInstance.dismiss('cancel');
                            };

                        },
                        resolve: {
                            thisPackage: function() {
                                return thisPackage;
                            }
                        }
                    });

				};

				/* Provides the ability to edit a given package. */
				$scope.edit = function(thisPackage) {

					$uibModal.open({
                        animation: true,
                        scope: $scope,
                        size: 'lg',
						templateUrl: 'directives/storePackagesTable/editModal.html',
                        controller: 'storePackagesTableEditPackageModal',
                        resolve: {
                            theStore: function(){
                                return $scope.store;

                            },
                            thePackage: function() {
                                return thisPackage;
                            }
                        }
					});
				};

				/* Provides the ability to add a new package. */
				$scope.add = function() {

					// var scope = $rootScope.$new();

					/* Add an empty package into scope */
		            // scope.package = { name: '', type: '$', products: [], active: false, require: false, exclusive: false, };

					/* Put the current store into the scope. */
					// scope.store = $scope.store;

		            $uibModal.open({
						templateUrl: 'directives/storePackagesTable/editModal.html',
                        scope: $scope,
                        size: 'lg',
						controller: function($scope, theStore, thePackage, $uibModalInstance) {

                            console.log('store', theStore);

                            $scope.thePackage = { name: '', type: '$', products: [], active: false, require: false, exclusive: false, };;

                            $scope.theStore = theStore;

							$scope.submit = function() {
                                if(!$scope.theStore.packages){
                                    $scope.theStore.packages = [];
                                }
								/* Add the package to the store.packages array. */
								$scope.theStore.packages.push($scope.thePackage);

                                $scope.theStore.$save().then(() => {

                                    $uibModalInstance.close();

                                });

							};

                            $scope.close = function() {

                                $uibModalInstance.dismiss('cancel');

                            }
						},
                        resolve: {
                            theStore: function(){
                                return $scope.store;

                            },
                            thePackage: function() {
                                return
                            }
                        }
					});
				};
			}
		};

	});

})();
